export const prm = [
  {
    name: "Mario",
    surname: "Rossi",
    lat: 40.8781,
    lng: 14.2833,
    ticketCode: "EJ463TR",
    destination: "Milano Linate",
    gate: "A2",
    time: "20:30",
    type: "WCHC"
  },
  {
    name: "Antonio",
    surname: "Bianchi",
    lat: 40.8782,
    lng: 14.2827,
    ticketCode: "RA4564UT",
    destination: "Munich",
    gate: "A12",
    time: "21:25",
    type: "WCHR"
  },
  {
    name: "Francesco",
    surname: "Esposito",
    lat: 40.8783,
    lng: 14.2817,
    ticketCode: "GS355GD",
    destination: "Lisbon",
    gate: "A1",
    time: "17:30",
    type: "WCHS"
  },
  {
    name: "Maria",
    surname: "Santiago",
    lat: 40.8784,
    lng: 14.283,
    ticketCode: "YH463EX",
    destination: "Bruxelles",
    gate: "B5",
    time: "18:20",
    type: "DEAF"
  },
  {
    name: "John",
    surname: "Skinner",
    lat: 40.8785,
    lng: 14.2821,
    ticketCode: "RT890FH",
    destination: "Catania",
    gate: "C6",
    time: "19:35",
    type: "BLIND"
  },
  {
    name: "Serena",
    surname: "Gomez",
    lat: 40.878,
    lng: 14.2815,
    ticketCode: "TE536YS",
    destination: "Amsterdam",
    gate: "D4",
    time: "20:25",
    type: "STCR"
  },
  {
    name: "João Pedro",
    surname: "Brito",
    lat: 40.877,
    lng: 14.284,
    ticketCode: "ND335AR",
    destination: "Berlin",
    gate: "F9",
    time: "16:45",
    type: "DPNA"
  },
  {
    name: "Rosa",
    surname: "Bianchi",
    lat: 40.8767,
    lng: 14.2843,
    ticketCode: "WC466VR",
    destination: "Miami",
    gate: "C1",
    time: "18:10",
    type: "MEDA"
  },
  {
    name: "Amanda",
    surname: "Klimt",
    lat: 40.877,
    lng: 14.2845,
    ticketCode: "SC356RT",
    destination: "New York",
    gate: "B7",
    time: "21:50",
    type: "MAAS"
  }
];

export const prmTypes = [
  "WCHC",
  "WCHR",
  "WCHS",
  "DEAF",
  "BLIND",
  "STCR",
  "DPNA",
  "MEDA",
  "MAAS"
];

export const flights = [
  {
    code: "LC019031",
    departure: "Munich",
    arrival: "Naples"
  },
  {
    code: "AG446FG",
    departure: "London",
    arrival: "Naples"
  },
  {
    code: "AS789YA",
    departure: "Naples",
    arrival: "Frankfurt"
  }
];

export const callPoints = [
  "Parcheggio",
  "Ingresso",
  "Sala amica land side",
  "Sala amica air side",
  "Check-in"
];

export const insiders = [
  "Gallo",
  "Simeoli",
  "D'Acunto",
  "Perna",
  "Benedetti",
  "Pratt"
];
